'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisStarController = function () {
    function FeisStarController($mdDialog) {
        _classCallCheck(this, FeisStarController);

        this._ = { $mdDialog: $mdDialog };
    }

    _createClass(FeisStarController, [{
        key: 'showStarNote',
        value: function showStarNote(e) {
            e.preventDefault();
            e.stopPropagation();

            this._.$mdDialog.show(this._.$mdDialog.alert().clickOutsideToClose(true).textContent('Starring or registering for a Feis grants the Feis organizers and School teachers the ability to view and modify my registration and account information.').ok('Got it!').targetEvent(e));
        }
    }]);

    return FeisStarController;
}();

exports.default = angular.module('ifeis.feis-star', ['ngMaterial']).directive('fFeisStar', function () {
    return {
        bindToController: true,
        controller: FeisStarController,
        controllerAs: 'star',
        restrict: 'E',
        template: require('./tpl.html')
    };
});


//////////////////
// WEBPACK FOOTER
// ./feis-list/star-help/index.js
// module id = 138
// module chunks = 0